export default __webpack_public_path__ + "static/media/Legguards of the Ostiary.8e71ecb7.jpg";